import jump from 'jump.js'

import humanDate from '../functions/humanDate'
import priceHelper from '../functions/priceHelper'
import timeFromGap from '../functions/timeFromGap'

export default {
  computed: {
    ticketsGapTime () {
      return timeFromGap(this.$store.state.cart.tickets.gap)
    },
    reservationsGapTime () {
      return timeFromGap(this.$store.state.cart.reservations.gap)
    },
    articleTypes () {
      const labels = {
        de: {},
        en: {}
      }

      for (const key in this.$store.state.articles) {
        labels.de[key] = this.$store.state.articles[key].text_de
        labels.en[key] = this.$store.state.articles[key].text_en
      }

      return labels
    },
    tours () {
      const {
        date,
        articles,
        total_articles: articleAmount,
        subtotal,
        fee_total: fee
      } = this.$store.state.cart.tours

      const groupedArticles = {}

      for (const id in articles) {
        articles[id].forEach(item => {
          const time = item.time.slice(0, -3)
          const gap = groupedArticles[time]

          const article = {
            id,
            count: item.count,
            price: item.discounted_price,
            subtotal: item.subtotal
          }

          if (gap) {
            gap.articles.push(article)
          } else {
            groupedArticles[time] = {
              name: item.name,
              articles: [article]
            }
          }
        })
      }

      return { date, subtotal, fee, groupedArticles, articleAmount }
    },
    hasYullbe () {
      const articles = this.$store.state.cart.tours.articles

      for (const id in articles) {
        if (id.startsWith('2_')) {
          return true
        }
      }

      return false
    }
  },

  methods: {
    typeName (id) {
      return this.$store.state.ticketSelection.ticketTypes[id]
    },
    humanDate (date) {
      const prettyDate = humanDate(date, this.$i18n.locale)
      return `${prettyDate.weekday.short}, ${prettyDate.date.long}`
    },
    humanPrice (price) {
      return priceHelper.format(price / 100, this.$i18n.locale)
    },
    scrollToRecommendations () {
      jump('#recommendation-list', { duration: 500 })
    }
  }
}
